import { AppPath } from 'utils/url/appPaths';
import { AppUrlOptions, createAppUrl } from 'utils/url/createAppUrl';
import { hasParams } from 'utils/url/createAppUrl/utils/hasParams';

/**
 * Creates the `to` string for the app links.
 *
 * @param options The props.
 */
export function createTo<TAppPath extends AppPath>(
  options: AppUrlOptions<TAppPath>,
): string {
  return hasParams(options)
    ? createAppUrl({ path: options.path, params: options.params })
    : createAppUrl({ path: options.path });
}
